const getIsCategoryCompleted = (category, checklist) =>
  category.items.every((item) => checklist[item]);

export default getIsCategoryCompleted;
